import classNames from 'classnames';

import ArrowRightIcon from '@svg/arrows-right.svg';

// styles
import s from './SliderArrow.sss';

// types
export type SliderArrowProps = {
  // className ignored to remove default slick slider styles
  // use overrideClassName instead
   
  className?: string
  overrideClassName?: string
  direction?: 'left' | 'right';
  onClick?(): void;
};

export const SliderArrow: React.FC<SliderArrowProps> = ({
  onClick,
  direction = 'right',
  overrideClassName,
}) => (
  <div
    className={classNames(
      s.root,
      { [s.arrowLeft]: direction === 'left' },
      { [s.arrowRight]: direction === 'right' },
      overrideClassName,
    )}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyPress={onClick}
  >
    <ArrowRightIcon
      className={s.icon}
      width='24'
      height='24'
    />
  </div>
);
